<template>
  <div class="knowledge-detail-mobile">
    <!-- Header -->
    <div class="header">
      <span class="back-arrow" @click="goBack">
        <img
          src="@/assets/svg/Arrow_Back.svg"
          alt="back"
          style="width: 6.51vw; height: 6.51vw;"
        />
      </span>

      <h1 class="page-title">{{ langTransfer(baseData.name) }}</h1>
      <div class="header-right"></div>
      <!-- For alignment -->
    </div>

    <!-- Main Content -->
    <div class="main-container">
      <!-- Left Sidebar -->
      <div class="sidebar">
        <div
          v-for="(category, index) in catelog"
          :key="index"
          class="category-group"
        >
          <!-- Category Title -->
          <div
            class="category-title"
            @click="toggleCategory(category.unique_code)"
          >
            {{ langTransfer(category.name) }}
          </div>

          <!-- Sub Menu Items -->
          <div
            class="sub-menu-container"
            :class="{
              expanded: expandedCategories.includes(category.unique_code),
            }"
          >
            <div class="sub-menu-wrapper">
              <div
                v-for="(subItem, subIndex) in category.child"
                :key="subIndex"
                class="sub-menu-item"
                :class="{ active: activedMenu === subItem.unique_code }"
                @click="handleSubMenuClick(subItem, category.name)"
              >
                {{ langTransfer(subItem.name) }}
              </div>
            </div>
          </div>
        </div>
        <!-- 占位100px -->
        <div style="height: 88px;"></div>
      </div>

      <!-- Right Content -->
      <div class="content-area" @scroll="handleScroll">
        <!-- Skeleton Loading -->
        <div v-if="loading" class="skeleton-wrapper">
          <div
            v-for="index in 7"
            :key="'skeleton-' + index"
            class="skeleton-item"
          >
            <div class="skeleton-info">
              <div class="skeleton-title skeleton-animate"></div>
              <div
                class="skeleton-title skeleton-animate"
                style="width: 60%;"
              ></div>
              <div class="skeleton-tags skeleton-animate"></div>
            </div>
            <div class="skeleton-image skeleton-animate"></div>
          </div>
        </div>

        <!-- Article List -->
        <div
          v-else
          v-for="(item, index) in list"
          :key="index"
          class="article-item"
          @click="goDetail(item)"
        >
          <div class="article-info">
            <div class="article-title">
              {{ langTransfer(item.title) }}
            </div>
            <div class="article-tags">
              {{
                langTransfer(
                  `${item.torFOriginal} | ${item.cate_name} ${item.author_name}`
                )
              }}
            </div>
          </div>
          <img
            v-if="item.poster"
            :src="item.poster"
            class="article-image"
            alt=""
          />
        </div>

        <!-- Load More / No More -->
        <div v-if="!loading" class="load-more-wrapper">
          <!-- Loading More Indicator -->
          <div v-if="loadingMore" class="loading-more">
            <div class="loading-spinner"></div>
            <span>加载中...</span>
          </div>
          <!-- No More Text -->
          <div v-else-if="list.length > 0 && getAll" class="no-more-text">
            - 没有更多了 -
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuthorArticleList, getKonwledgeList } from '@/api/hb';
import { authentication } from '@/api/lxc';
import store from '@/store';

export default {
  name: 'KnowledgeDetailMobile',
  data() {
    return {
      baseData: {},
      list: [],
      activedMenu: '',
      checkedSubMenuObj: undefined,
      getAll: false,
      expandedCategories: [], // 展开的分类列表
      uniqueOpened: true, // 是否只保持一个子菜单的展开（手风琴模式）
      loading: false, // 加载状态
      loadingMore: false, // 加载更多状态
    };
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
    catelog() {
      const { baseData } = this;
      if (baseData.child && baseData.child.length > 0) {
        return baseData.child;
      }
      return [];
    },
    user_unique_code() {
      return this.$store.state.user_unique_code;
    },
  },
  watch: {
    // 监听 webInfo 的变化,确保 service_code 存在后再加载数据
    'webInfo.service_code': {
      handler(newVal) {
        if (newVal && !this.baseData.name) {
          // 使用 nextTick 确保在下一个 DOM 更新周期执行
          this.$nextTick(() => {
            this.getKonwledgeDetail();
          });
        }
      },
      immediate: true, // 立即执行一次,如果 service_code 已存在
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    handleScroll(e) {
      // 防止重复触发
      if (this.loading || this.loadingMore || this.getAll) {
        return;
      }

      const target = e.target;
      const scrollBottom =
        target.scrollHeight - target.scrollTop - target.clientHeight;

      // 距离底部 100px 时触发加载
      if (scrollBottom < 100) {
        this.loadMore();
      }
    },
    toggleCategory(categoryCode) {
      const index = this.expandedCategories.indexOf(categoryCode);

      if (this.uniqueOpened) {
        // 手风琴模式：只保持一个分类展开
        if (index > -1) {
          // 如果点击的是已展开的分类，则收起
          this.expandedCategories.splice(index, 1);
        } else {
          // 如果点击的是未展开的分类，关闭其他所有分类，只展开当前分类
          this.expandedCategories = [categoryCode];
        }
      } else {
        // 多选模式：可以同时展开多个分类
        if (index > -1) {
          // 如果已经展开，则收起
          this.expandedCategories.splice(index, 1);
        } else {
          // 如果未展开，则展开
          this.expandedCategories.push(categoryCode);
        }
      }
    },
    loadMore() {
      if (this.getAll || this.loadingMore) {
        return;
      }
      const newPage = Math.ceil(this.list.length / 10) + 1;
      this.getArticleList(newPage);
    },
    handleSubMenuClick(item, parentName) {
      this.checkedSubMenuObj = item;
      this.checkedSubMenuObj.__parentName = parentName;
      this.activedMenu = item.unique_code;
      this.getAll = false;
      this.list = [];
      this.getArticleList();

      // Update route params
      this.$router.replace({
        params: {
          subId: item.unique_code,
        },
      });
    },
    initActiveMenu() {
      const { baseData } = this;
      if (this.$route.params.subId) {
        this.activedMenu = this.$route.params.subId;
        const arrSub = [];
        baseData.child.forEach((e) => {
          e.child.forEach((sub) => {
            arrSub.push(sub);
          });
        });
        const obj = arrSub.find((e) => {
          return e.unique_code === this.$route.params.subId;
        });
        this.checkedSubMenuObj = obj;
        this.checkedSubMenuObj.__parentName = this.findCheckedParentName();

        // 自动展开包含当前选中项的分类
        const parentCategory = baseData.child.find((category) => {
          return category.child.some(
            (sub) => sub.unique_code === this.$route.params.subId
          );
        });
        if (
          parentCategory &&
          !this.expandedCategories.includes(parentCategory.unique_code)
        ) {
          this.expandedCategories.push(parentCategory.unique_code);
        }

        this.getAll = false;
        this.getArticleList();
        return;
      }
      this.activedMenu = baseData.child[0].child[0].unique_code;
      [this.checkedSubMenuObj] = baseData.child[0].child;
      this.checkedSubMenuObj.__parentName = baseData.child[0].name;

      // 默认展开第一个分类
      if (
        baseData.child.length > 0 &&
        !this.expandedCategories.includes(baseData.child[0].unique_code)
      ) {
        this.expandedCategories.push(baseData.child[0].unique_code);
      }

      this.getAll = false;
      this.getArticleList();
    },
    findCheckedParentName() {
      const { checkedSubMenuObj } = this;
      const result = this.catelog.find((e) => {
        return (
          e.child.findIndex((sub) => {
            return sub.unique_code === checkedSubMenuObj.unique_code;
          }) !== -1
        );
      });
      return result ? result.name : '';
    },
    async getKonwledgeDetail() {
      try {
        const data = await getKonwledgeList({
          service_code: this.webInfo.service_code,
          tag: 6,
          parent_code: this.$route.params.id,
        });
        this.baseData = data;
        if (data.child && data.child.length > 0) {
          this.initActiveMenu();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getArticleList(page = 1) {
      try {
        if (!this.checkedSubMenuObj) {
          return;
        }

        // 首次加载显示骨架屏
        if (page === 1) {
          this.loading = true;
        } else {
          // 加载更多显示底部 loading
          this.loadingMore = true;
        }

        const { unique_code } = this.checkedSubMenuObj;
        const data = await getAuthorArticleList({
          author_unique_code: unique_code,
          page,
          pageSize: 10,
          user_unique_code: this.user_unique_code,
        });

        if (data.length < 10) {
          this.getAll = true;
        }
        if (page !== 1) {
          this.list = this.list.concat(data);
          return;
        }
        this.list = data;
      } catch (err) {
        if (err.code === '-1') {
          this.getAll = true;
        }
        console.log(err);
      } finally {
        this.loading = false;
        this.loadingMore = false;
      }
    },
    goDetail(item) {
      console.log('goDetail', item);

      this.$router.push({
        name: 'knowledgeLibArticle',
        params: {
          id: item.unique_code,
          secParentId: this.$route.params.id,
          authorName: item.author_name,
        },
      });
    },
    langTransfer(text) {
      return text;
    },
  },
  beforeRouteUpdate(to, from, next) {
    this.getAll = false;
    this.getArticleList();
    next();
  },
  beforeRouteEnter: (to, from, next) => {
    next((vm) => {
      const { service_code } = vm.webInfo;
      if (service_code) {
        vm.getKonwledgeDetail();
      }
    });
  },
};
</script>

<style scoped lang="less">
.knowledge-detail-mobile {
  width: 100vw;
  min-height: 100vh;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
}

/* Header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3.72vw 4.65vw; /* 16px 20px */
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 100;
}

.back-arrow {
  font-size: 6.51vw; /* ~28px */
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  line-height: 1;
}

.back-arrow:hover {
  color: #007bff; /* Optional hover effect */
}

.page-title {
  font-size: 4.65vw; /* ~20px */
  font-weight: bold;
  color: #333;
  margin: 0;
}

.header-right {
  width: 6.51vw; /* To balance the layout if no right element exists */
}

/* Main Container */
.main-container {
  display: flex;
  flex: 1;
  width: 100%;
  height: auto;
  overflow: hidden;
}

/* Sidebar */
.sidebar {
  width: 27.91vw; /* 120px */
  background-color: #e4e7ed;
  overflow-x: hidden;
  overflow-y: auto;
  flex-shrink: 0;
}

.category-group {
  width: 100%;
}

.category-title {
  width: 27.91vw; /* 120px */
  padding: 3.26vw 1.6vw; /* 14px */
  text-align: center;
  font-size: 4.19vw; /* 18px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
  font-weight: 700;
  line-height: 4.65vw; /* 20px */
  color: #303133;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.3s;
}

.sub-menu-container {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease;
  overflow: hidden;
}

.sub-menu-container.expanded {
  grid-template-rows: 1fr;
}

.sub-menu-wrapper {
  min-height: 0;
  width: 27.91vw; /* 120px */
  padding: 0 1.4vw; /* 6px */
  display: flex;
  flex-direction: column;
}

.sub-menu-item {
  width: 100%;
  padding: 2.33vw 0; /* 10px */
  text-align: center;
  font-size: 3.26vw; /* 14px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
  font-weight: 400;
  line-height: 4.65vw; /* 20px */
  color: #303133;
  border-radius: 2.33vw; /* 10px */
  cursor: pointer;
  transition: all 0.3s;

  &.active {
    background-color: #ffffff;
    font-weight: 700;
  }
}

/* Content Area */
.content-area {
  flex: 1;
  width: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 88px;
}

/* Skeleton Loading */
.skeleton-wrapper {
  width: 100%;
}

.skeleton-item {
  width: 72.09vw; /* 310px */
  display: flex;
  padding: 3.72vw; /* 16px */
  gap: 2.33vw; /* 10px */
  background-color: #ffffff;
}

.skeleton-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2.33vw; /* 10px */
  overflow: hidden;
}

.skeleton-title {
  height: 6.51vw; /* 28px */
  background-color: #f2f2f2;
  border-radius: 1.16vw; /* 5px */
  width: 100%;
}

.skeleton-tags {
  height: 3.72vw; /* 16px */
  background-color: #f2f2f2;
  border-radius: 1.16vw; /* 5px */
  width: 50%;
}

.skeleton-image {
  width: 25.58vw; /* 110px */
  height: 25.58vw; /* 110px */
  background-color: #f2f2f2;
  border-radius: 2.79vw; /* 12px */
  flex-shrink: 0;
}

/* Skeleton Animation */
@keyframes skeleton-loading {
  0% {
    background-color: #f2f2f2;
  }
  50% {
    background-color: #e6e6e6;
  }
  100% {
    background-color: #f2f2f2;
  }
}

.skeleton-animate {
  animation: skeleton-loading 1.5s ease-in-out infinite;
}

.article-item {
  width: 72.09vw; /* 310px */
  display: flex;
  padding: 3.72vw; /* 16px */
  gap: 2.33vw; /* 10px */
  background-color: #ffffff;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #f5f7fa;
  }
}

.article-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.93vw; /* 4px */
  overflow: hidden;
}

.article-title {
  font-size: 4.65vw; /* 20px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
  font-weight: 400;
  line-height: 6.51vw; /* 28px */
  color: #3d3d3d;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article-tags {
  font-size: 2.79vw; /* 12px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
  font-weight: 700;
  line-height: 3.72vw; /* 16px */
  color: #909399;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.article-image {
  width: 25.58vw; /* 88px */
  height: 25.58vw; /* 88px */
  border-radius: 2.79vw; /* 12px */
  object-fit: cover;
  flex-shrink: 0;
}

/* Load More */
.load-more-wrapper {
  padding: 4.65vw 0; /* 20px */
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Loading More Indicator */
.loading-more {
  display: flex;
  align-items: center;
  gap: 2.33vw; /* 10px */
  color: #909399;
  font-size: 3.26vw; /* 14px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
}

.loading-spinner {
  width: 4.65vw; /* 20px */
  height: 4.65vw; /* 20px */
  border: 0.47vw solid #f3f3f3; /* 2px */
  border-top: 0.47vw solid #409eff; /* 2px */
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.load-more-btn {
  padding: 2.33vw 4.65vw; /* 10px 20px */
  background-color: #409eff;
  color: #ffffff;
  border: none;
  border-radius: 1.16vw; /* 5px */
  font-size: 3.26vw; /* 14px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
  cursor: pointer;
  transition: background-color 0.3s;
}

.no-more-text {
  font-size: 3.26vw; /* 14px */
  font-family: 'Alibaba PuHuiTi 3.0', sans-serif;
  color: #aaa9a9;
  user-select: none;
}
</style>
